// extracted by mini-css-extract-plugin
export var askRedoIcon = "_b-f";
export var askRedoTag = "_b-8";
export var askRedoText = "_b-e";
export var brandGroup = "_b-2";
export var chevron = "_b-p";
export var chevronActive = "_b-q";
export var chevronDown = "_b-l";
export var divider = "_b-r";
export var exitIcon = "_b-b";
export var exitTag = "_b-7";
export var exitText = "_b-d";
export var header = "_b-0";
export var logo = "_b-4";
export var navBar = "_b-1";
export var productIcon = "_b-9";
export var productName = "_b-c";
export var productTag = "_b-5";
export var profileAvatar = "_b-h";
export var profileGroup = "_b-g";
export var profileImage = "_b-i";
export var profileInitials = "_b-j";
export var progressFill = "_b-t";
export var progressTrack = "_b-s";
export var rightGroup = "_b-3";
export var stepLabel = "_b-n";
export var stepLabelActive = "_b-o";
export var stepLabels = "_b-m";
export var storeName = "_b-k";
export var themeIcon = "_b-a";
export var themeTag = "_b-6";